import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

type CountryTagSorting = '-popularity' | '-excursions_count' | '-tours_count';

const DEFAULT_PAGE_SIZE = 300;

interface Params {
  slug: MaybeRefOrGetter<string>;
  pageSize?: MaybeRefOrGetter<number>;
  sorting?: MaybeRefOrGetter<CountryTagSorting>;
  enabled?: MaybeRefOrGetter<boolean>;
}

const setParams = (params: Params): Required<Params> => {
  return {
    slug: params.slug,
    pageSize: params?.pageSize || computed(() => DEFAULT_PAGE_SIZE),
    sorting: params?.sorting || computed(() => '-popularity'),
    enabled: params?.enabled !== undefined ? params?.enabled : computed(() => true),
  };
};
export const useCountryTag = (params: Params) => {
  const { slug, pageSize, enabled, sorting } = setParams(params);
  const { getCountryTags } = useExperienceApi();

  const { data: countryTags } = useQuery({
    queryKey: ['countryTag', slug, pageSize, sorting],
    queryFn: () => {
      return getCountryTags({
        query: {
          country__slug: unref(slug) as string,
          page_size: unref(pageSize) as number,
          sorting: unref(sorting) as CountryTagSorting,
        },
      });
    },
    enabled: computed(() => !!ref(enabled)),
    placeholderData: (prev) => prev,
    select: (response) => response.data?.results,
    retry: false,
  });

  return {
    countryTags,
  };
};
